export default __webpack_public_path__ + "static/media/sanjya-dubri-National-Park.731b4ca6.jpg";